"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.BmInputElement = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _bmFormEvents = require("../../bm-form-events");

var _itemRenderer = require("../item-engine/item-renderer");

var BmInputElement = /*#__PURE__*/function (_bmFormEventDispatche) {
  (0, _inherits2.default)(BmInputElement, _bmFormEventDispatche);

  var _super = (0, _createSuper2.default)(BmInputElement);

  function BmInputElement() {
    (0, _classCallCheck2.default)(this, BmInputElement);
    return _super.apply(this, arguments);
  }

  return BmInputElement;
}((0, _bmFormEvents.bmFormEventDispatcher)(_itemRenderer.BmItemElement));

exports.BmInputElement = BmInputElement;
